import React from 'react'
import {Listings} from './Listings'
import {textStrings} from './textStrings'
import {useStore} from 'react-hookstore'

export default function Events() {
  const [lang] = useStore('language')
  return(
    <div className="events">
      <div>
        <span className="title">
          {textStrings.events[lang]}
        </span>
        <hr/>
        <Listings nore='events'/>
      </div>
    </div>
  )
}
